import type { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import api from '../../axios/api/snsConnection';
import {
  addSnsConnectionSuccess,
  deleteSnsConnectionSuccess,
  editSnsConnectionSuccess,
  fetchSnsConnectionsFailure,
  fetchSnsConnectionsStart,
  fetchSnsConnectionsSuccess
} from '../slices/SnsConnectionSlice';

import type {
  UserSnsConnection,
  CreateUserSnsConnectionRequest,
  UpdateUserSnsConnectionRequest,
} from '../../interface/I_userSnsConnection';

function* fetchSnsConnections(action: PayloadAction<{ userId: string }>) {
  try {
    const res: UserSnsConnection[] = yield call(api.fetchByUser, action.payload.userId);
    yield put(fetchSnsConnectionsSuccess(res));
  } catch (e: any) {
    yield put(fetchSnsConnectionsFailure(e.message));
  }
}

function* addSnsConnection(action: PayloadAction<CreateUserSnsConnectionRequest>) {
  try {
    const res: UserSnsConnection = yield call(api.add, action.payload);
    yield put(addSnsConnectionSuccess(res));
  } catch (e: any) {
    yield put(fetchSnsConnectionsFailure(e.message));
  }
}

function* editSnsConnection(
  action: PayloadAction<{ id: number; data: UpdateUserSnsConnectionRequest }>,
) {
  try {
    const res: UserSnsConnection = yield call(api.edit, action.payload.id, action.payload.data);
    yield put(editSnsConnectionSuccess(res));
  } catch (e: any) {
    yield put(fetchSnsConnectionsFailure(e.message));
  }
}

function* deleteSnsConnection(action: PayloadAction<number>) {
  try {
    yield call(api.delete, action.payload);
    yield put(deleteSnsConnectionSuccess(action.payload));
  } catch (e: any) {
    yield put(fetchSnsConnectionsFailure(e.message));
  }
}

export default function* SnsConnectionSaga() {
  yield takeLatest('snsConnection/fetchSnsConnectionsStart', fetchSnsConnections);
  yield takeLatest('snsConnection/addSnsConnection', addSnsConnection);
  yield takeLatest('snsConnection/editSnsConnection', editSnsConnection);
  yield takeLatest('snsConnection/deleteSnsConnection', deleteSnsConnection);
}
